import clsx, { type ClassValue } from "clsx";

/**
 * Class-name merger. Thin wrapper around clsx so the import path is the
 * idiomatic single name everyone uses across components.
 */
export function cn(...args: ClassValue[]): string {
    return clsx(args);
}
